import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus",
  "use": "plus-usage",
  "viewBox": "0 0 28 27",
  "content": "<symbol viewBox=\"0 0 28 27\" xmlns=\"http://www.w3.org/2000/svg\" id=\"plus\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M27.48 14.247l-26.475.143-.011-2 26.476-.143.01 2z\" fill=\"currentColor\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.237 26.557V.081h2v26.476h-2z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id